import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ShoppingBag } from 'lucide-react';
import { SHOP_URL } from '../../data/ribbonData';

const LOGO = 'https://customer-assets.emergentagent.com/job_style-central-65/artifacts/n560cpi8_Untitled%20design%20%2820%29.png';
const LINKS = [
  { to: '/', label: 'Home' },
  { to: '/native-ribbon', label: 'Native Ribbon' },
  { to: '/zen-tshirts', label: "Zen's T-Shirts" },
];

export const RibbonNav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50" data-testid="ribbon-nav">
      <div className="bg-gradient-to-r from-[#ff8a00] via-[#ff4d00] to-[#ff8a00] text-black text-xs sm:text-sm text-center py-2 font-semibold tracking-wide" data-testid="ribbon-announcement">
        Native-owned · California basket-inspired satin ribbon · 10 yards per roll
      </div>
      <div className="bg-black/60 backdrop-blur-xl border-b border-[#ff6a00]/30 shadow-[0_0_30px_rgba(255,106,0,0.15)]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="ribbon-nav-logo">
            <img src={LOGO} alt="Finest Feathers" className="h-10 w-auto drop-shadow-[0_0_10px_rgba(255,106,0,0.7)]" />
            <span className="rb-head text-xl rb-neon">Finest Feathers</span>
          </Link>
          <nav className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`ribbon-nav-${l.label.toLowerCase().replace(/[^a-z]/g, '')}`}
                className={`text-sm font-semibold uppercase tracking-wider transition-colors ${l.to === '/native-ribbon' ? 'text-[#ff9a3c] [text-shadow:0_0_12px_#ff6a00]' : 'text-white/60 hover:text-white'}`}>
                {l.label}
              </Link>
            ))}
          </nav>
          <a href={SHOP_URL} target="_blank" rel="noopener noreferrer" data-testid="ribbon-nav-shop-btn"
            className="hidden md:inline-flex items-center gap-2 rounded-full rb-btn px-5 py-2.5 text-sm font-bold uppercase tracking-wider">
            <ShoppingBag className="w-4 h-4" /> Shop Ribbon
          </a>
          <button onClick={() => setOpen(!open)} className="md:hidden p-2 rounded-full rb-btn-ghost" data-testid="ribbon-mobile-menu-toggle" aria-label="Menu">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
        {open && (
          <nav className="md:hidden px-5 pb-5 flex flex-col gap-3" data-testid="ribbon-mobile-menu">
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="py-2 text-white font-semibold uppercase tracking-wider">{l.label}</Link>
            ))}
            <a href={SHOP_URL} target="_blank" rel="noopener noreferrer" className="rounded-full rb-btn text-center py-3 font-bold uppercase">Shop Ribbon</a>
          </nav>
        )}
      </div>
    </header>
  );
};
